import { useEffect, useRef, useState } from 'react';
import './Update.css';
import { Button, CircularProgress, MenuItem, Slider, TextField } from '@mui/material';
import { useHistory, useLocation } from "react-router-dom";
import { IonButton, IonButtons, IonContent, IonHeader, IonModal, IonTitle, IonToolbar, useIonRouter } from '@ionic/react';
import imageCompression from 'browser-image-compression';
import { Preferences } from '@capacitor/preferences';
import EditCropper from 'react-cropper';
import { useSnackbar } from 'notistack';
import Cropper from 'react-easy-crop';
import "cropperjs/dist/cropper.css";
import axios from 'axios';
import SignatureCanvas from 'react-signature-canvas';
// Function
import { getCroppedImg } from '../utils/cropImage';
import { dataURLtoFile } from '../../exportFunctions/standardExportFunctions';
// Components
import StandardButton from '../../components/StandardButton/StandardButton';
import IonicPageWrapper from '../../components/IonicPageWrapper/IonicPageWrapper';
import StandardTextfield from '../../components/StandardTextfield/StandardTextfield';
// IMGs
import frontViewImg from '../../imgs/front_viewImg.jpeg';
import uploadSignature from '../../imgs/uploadSignature.png';
import Compressor from "compressorjs";
import { download } from 'ionicons/icons';

function Update() {

    const [mobileNo, setMobileNo] = useState('');
    const [classId, setClassId] = useState('');
    const [name, setName] = useState('');
    // console.log(classId)
    useEffect(() => {
        const fetchMobileNumber = async () => {
            const { value } = await Preferences.get({ key: 'userMobile' });
            if (value) setMobileNo(value);
        };

        fetchMobileNumber();
    }, []);
 
    const history = useHistory()
    const ionRouter = useIonRouter();
    const { state, pathname } = useLocation();

    const { enqueueSnackbar } = useSnackbar()

    const cropperRef = useRef(null);

    const [loading, setLoading] = useState(true);
    const [IdCardData, setIdCardData] = useState({});

    const [updateDataTextField, setUpdateDataTextField] = useState({}) // ID Card Front Data Text
    const [updateDataImage, setUpdateDataImage] = useState({}); // ID Card Front Data Image

    const [updateDataTextFieldBack, setUpdateDataTextFieldBack] = useState({}) // ID Card Back Data Text
    const [updateDataImageBack, setUpdateDataImageBack] = useState({}); // ID Card Back Data Image

    const [updateDataImageFrontBackNew, setUpdateDataImageFrontBackNew] = useState({}); // ID Card Front & Back Data Image Change

    const [allClassData, setAllClassData] = useState([]); // All Class data is stored if input has tag class_id

    const [updateDataImageKey, setupdateDataImageKey] = useState(null);
    const [updateDataImageType, setupdateDataImageType] = useState(null);

    const [saveLoading, setSaveLoading] = useState(false);
    const [previewLoading, setPreviewLoading] = useState(false);
    const [editLoadingData, setEditLoadingData] = useState({ editTag: null, loading: false });

    const [image, setImage] = useState(null);
    // MODAL
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isEditModalOpen, setIsEditModalOpen] = useState(false);
    const [isSignatureModalOpen, setIsSignatureModalOpen] = useState(false);
    // CROP
    const [croppedArea, setCroppedArea] = useState(null);
    const [croppedImg, setCroppedImg] = useState(null);
    const [crop, setCrop] = useState({ x: 0, y: 0 });
    const [zoom, setZoom] = useState(1);
    // EDIT CROPPER
    const [editImage, setEditImage] = useState(null);
    const [editCropperZoom, setEditCropperZoom] = useState(0);
    // SIGNATURE PAD
    const signaturePadRef = useRef(null);
    const signatureContainerRef = useRef(null);

    useEffect(() => {
        // Log created links when coming from PreviewPage
        console.log("Update.jsx - Current state:", state);
        console.log("Update.jsx - Last pathname:", ionRouter?.routeInfo?.lastPathname);
        
        if (state?.createdLinks) {
            console.log("Created Links from PreviewPage:", state.createdLinks);
        }

        if (ionRouter?.routeInfo?.lastPathname === "/preview") {
            // If coming from preview, preserve the uploaded images from state
            if (state?.cardUpdate) {
                setIdCardData(state?.cData);
                getIDCardFields(state?.cData);
                setLoading(false);
            }
            fetchAllClass();
            return;
        }

        if (pathname === '/update') {
            if (!state?.cardUpdate) {
                getIdCardByID();
            } else {
                getIDCardFields(state?.cData);
                setIdCardData(state?.cData);
                setLoading(false);
            }
            fetchAllClass();
        }

        return () => {
            // setIdCardData({});
            // setUpdateDataTextField({})
            // setUpdateDataImage({})
            // setUpdateDataTextFieldBack({})
            // setUpdateDataImageBack({})
            setImage(null)
        }
    }, [pathname, state])
    
    // Preserve uploaded images when coming back from preview
    // This prevents re-uploading images that are already uploaded links
    useEffect(() => {
        if (ionRouter?.routeInfo?.lastPathname === "/preview" && state?.img_data && IdCardData) {
            // Override images with the uploaded ones from preview (preserve uploaded links)
            // This ensures we don't lose the links and re-upload them
            if (state.img_data.updateDataImage) {
                setUpdateDataImage(state.img_data.updateDataImage);
            }
            
            if (state.img_data.updateDataImageBack) {
                setUpdateDataImageBack(state.img_data.updateDataImageBack);
            }
            
            // Also preserve text fields from state if available
            if (state.user_data) {
                setUpdateDataTextField(prev => ({
                    ...prev,
                    ...state.user_data
                }));
                
                if (IdCardData?.type == 2) {
                    setUpdateDataTextFieldBack(prev => ({
                        ...prev,
                        ...state.user_data
                    }));
                }
            }
        }
    }, [IdCardData, state?.img_data, ionRouter?.routeInfo?.lastPathname])
    
    // Update class_id in form fields when classId state is set
    useEffect(() => {
        if (classId && IdCardData?.view_data?.id_front?.text_objects?.some(t => t.tag === 'class_id')) {
            setUpdateDataTextField(prev => ({
                ...prev,
                'class_id': classId
            }));
        }
        if (classId && IdCardData?.type == 2 && IdCardData?.view_data?.id_back?.text_objects?.some(t => t.tag === 'class_id')) {
            setUpdateDataTextFieldBack(prev => ({
                ...prev,
                'class_id': classId
            }));
        }
    }, [classId, IdCardData])
    const fetchAllClass = async (e) => {
        if (!state?.cData?.schoolid && !state?.cData?.school_id) return;

        const { value: classId } = await Preferences.get({ key: 'gjaii_IDCARD_user' });
        setName(JSON.parse(classId).first_name);
        var storedClassId = JSON.parse(classId).classid;
        console.log(storedClassId);
        await axios.post(`${process.env.REACT_APP_BASE_URL}/user/getclassesbyschoolid`, { schoolid: state?.cData.schoolid || state?.cData.school_id })
            .then(res => {
                if (res.data.success) {
                    setAllClassData(res.data.data)
                    // console.log(res.data.data)
                    const classData = res.data.data;
                    // console.log(classId);
                    // Check if the storedClassId matches any class in the fetched data
                    if (storedClassId) {
                        const matchedClass = classData.find(
                            (c) => {
                                 return `${c.classid}`.trim() === `${storedClassId}`.trim();
                            }
                        );
                        // console.log(matchedClass)

                        if (matchedClass) {
                            // Set the classId if a match is found
                            // setClassId(storedClassId);
                            setClassId(`${matchedClass.standard} ${matchedClass.division ? `- ${matchedClass.division}` : ""}`);
                            // console.log("Matched Class ID:", storedClassId);
                        } else {
                            console.log("No matching class ID found");
                        }
                    }
                } else {
                    enqueueSnackbar('Error Fetching Class, Try Again !!!', { variant: 'error' })
                }
            })
            .catch(err => {
                console.log(err);
                return enqueueSnackbar('Something Went Wrong !!!', { variant: 'error' })
            })
    }

    const getIdCardByID = async () => {
        await axios.post(`${process.env.REACT_APP_BASE_URL}/user/getidcard`, { card_id: state?.cData?.id })
            .then(res => {
                if (res.data.success) {
                    getIDCardFields(res.data.data);
                    setIdCardData(res.data.data)
                } else {
                    enqueueSnackbar(res.data.message, { variant: 'error' });
                }
                setLoading(false);
            })
            .catch(err => {
                console.log(err);
                setLoading(false);
                enqueueSnackbar('Error, Please Try Again !!!', { variant: 'error' });
            })
    }

    const getIDCardFields = async(cardData) => {
        const { value } = await Preferences.get({ key: 'userMobile' });

        const { value: classDet } = await Preferences.get({ key: 'gjaii_IDCARD_user' });


        // ID CARD FRONT PARSING
        let textfieldsObj = {};
        let textfieldsImgObj = {};

        cardData?.view_data?.id_front.text_objects.forEach(text => {
            if(text.tag === 'Mobile No.'){
                textfieldsObj = { ...textfieldsObj, [text.tag]: value }
            }
            else
            if(text.tag === 'class_id'){
                textfieldsObj = { ...textfieldsObj, [text.tag]: classId }
            }
            else if(text.tag === 'Name'){
                textfieldsObj = { ...textfieldsObj, [text.tag]: JSON.parse(classDet)?.first_name }
            }
            else{
            textfieldsObj = { ...textfieldsObj, [text.tag]: state?.cardUpdate ? text.text : '' }
            }
        })

        cardData?.view_data?.id_front.image_objects.forEach(img => {
            textfieldsImgObj = { ...textfieldsImgObj, [img.tag]: img?.src || '' }
        })

        // ID CARD BACK PARSING
        let textfieldsObjBack = {};
        let textfieldsImgObjBack = {};
       console.log(state?.cardUpdate)
        if (cardData?.type == 2) {
            cardData?.view_data?.id_back.text_objects.forEach(text => {
                if(text.tag === 'class_id'){
                    textfieldsObjBack = { ...textfieldsObjBack, [text.tag]: classId }
                }
                else if(text.tag === 'Name'){
                    textfieldsObjBack = { ...textfieldsObjBack, [text.tag]: (JSON.parse(classDet).first_name) }
                }
                else{
                    console.log(text.text,text.tag)
                    textfieldsObjBack = { ...textfieldsObjBack, [text.tag]: state?.cardUpdate ? text.text : '' }
                }
            })
            console.log(textfieldsObjBack)
            console.log(textfieldsObj)
            console.log(classId)

            cardData?.view_data?.id_back.image_objects.forEach(img => {
                textfieldsImgObjBack = { ...textfieldsImgObjBack, [img.tag]: img.src || '' }
            })
        }
        // 

        // Update Image Change
        const commonImgKeyArr = Object.keys({ ...textfieldsImgObj, ...textfieldsImgObjBack })
        let updateDataImageFrontBackNew = {};
        commonImgKeyArr?.forEach(key => updateDataImageFrontBackNew = { ...updateDataImageFrontBackNew, [key]: false })
        setUpdateDataImageFrontBackNew(updateDataImageFrontBackNew)
        // 

        setUpdateDataTextField(textfieldsObj); // FRONT
        setUpdateDataImage(textfieldsImgObj); // FRONT

        setUpdateDataTextFieldBack(textfieldsObjBack); // BACK
        setUpdateDataImageBack(textfieldsImgObjBack); // BACK
    }

    const onSelectFile = async (event, key, type) => {
        if (event.target.files && event.target.files.length > 0) {
            setIsModalOpen(true);
            setupdateDataImageKey(key);
            setupdateDataImageType(type);
            if (state?.teacherVerify_edit) setUpdateDataImageFrontBackNew({ ...updateDataImageFrontBackNew, [key]: true })

            // const reader = new FileReader();
            // reader.readAsDataURL(event.target.files[0]);
            // reader.addEventListener("load", () => {
            //     setImage(reader.result);
            // });
            const file = event.target.files[0];

            // const orientation = await imageCompression.getExifOrientation(file);
            // // console.log(orientation);

            // const options = {
            //   maxSizeMB: 5,
            //   maxWidthOrHeight: 1920,
            //   useWebWorker: true,
            //   exifOrientation: orientation,
            // };

            try {
                // const compressedFile = await imageCompression(event.target.files[0], options);

                new Compressor(file, {
                    quality: 0.6, // 0.6 can also be used, but its not recommended to go below.
                    //   maxWidth : 1920,
                    success: (compressedResult) => {
                        // compressedResult has the compressed file.
                        // Use the compressed file to upload the images to your server.
                        const reader = new FileReader();
                        reader.readAsDataURL(compressedResult);
                        reader.addEventListener("load", () => {
                            setImage(reader.result);
                        });
                    },
                });
            } catch (error) {
                console.log(error);
            }
        }
    };

    const onSave = async () => {
        // generateDownload(image, croppedArea);

        if (!croppedArea || !image || !updateDataImageKey || !updateDataImageType) return;

        const canvas = await getCroppedImg(image, croppedArea);
        const fileType = image.split(';')[0].split(':')[1];

        canvas.toBlob(
            (blob) => {
                // const previewUrl = window.URL.createObjectURL(blob);

                // const anchor = document.createElement("a");
                // anchor.download = "image.jpeg";
                // anchor.href = URL.createObjectURL(blob);
                // anchor.click();

                // window.URL.revokeObjectURL(previewUrl);
                // setCroppedImageURL(URL.createObjectURL(blob));
                const reader = new FileReader();
                reader.readAsDataURL(blob);
                reader.addEventListener("load", () => {
                    // setCroppedImg(reader.result);
                    if (updateDataImageType == "front") {
                        setUpdateDataImage({
                            ...updateDataImage,
                            [updateDataImageKey]: reader.result,
                        });
                    } else {
                        setUpdateDataImageBack({
                            ...updateDataImageBack,
                            [updateDataImageKey]: reader.result,
                        });
                    }

                    // Reset
                    setIsModalOpen(false);
                    setupdateDataImageKey(null);
                    setupdateDataImageType(null);
                    setImage(null);
                    setCroppedImg(null);
                    setCrop({ x: 0, y: 0 });
                    setZoom(1);
                });
                // console.log(URL.createObjectURL(blob));
                // setIsModalOpen(true);
            },
            fileType,
            0.66
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        const { value } = await Preferences.get({
            key: "gjaai_num10digit",
          });
        
        // Validate required text fields (excluding class_id as it's auto-populated)
        const frontRequiredFields = IdCardData?.view_data?.id_front?.text_objects?.filter(t => t.required && t.tag !== 'class_id') || [];
        const backRequiredFields = IdCardData?.view_data?.id_back?.text_objects?.filter(t => t.required && t.tag !== 'class_id') || [];
        
        const missingRequiredFields = [];
        
        // Check front required fields
        frontRequiredFields.forEach(field => {
            const fieldValue = updateDataTextField[field.tag];
            if (!fieldValue || fieldValue.trim() === '') {
                missingRequiredFields.push(field.tag);
            }
        });
        
        // Check back required fields
        if (IdCardData.type == 2) {
            backRequiredFields.forEach(field => {
                const fieldValue = updateDataTextFieldBack[field.tag];
                if (!fieldValue || fieldValue.trim() === '') {
                    missingRequiredFields.push(field.tag);
                }
            });
        }
        
        if (missingRequiredFields.length > 0) {
            return enqueueSnackbar(`Please fill all required fields: ${missingRequiredFields.join(', ')}`, { variant: 'error' });
        }
        
        // if (Object.values(updateDataTextField)?.some(t => t?.trim() === '') || Object.values(updateDataTextFieldBack)?.some(t => t?.trim() === '') || Object.values(updateDataImage)?.some(t => t?.trim() === '') || Object.values(updateDataImageBack)?.some(t => t?.trim() === '')) return enqueueSnackbar('Please Fill All The Details !!!', { variant: 'error' });
      if(value == 'false'){
        if (Object.values(updateDataImage)?.some(t => t?.trim() === '') || Object.values(updateDataImageBack)?.some(t => t?.trim() === '')) return enqueueSnackbar('Image is compulsory!', { variant: 'error' });
      }

        setPreviewLoading(true);

        try {
            // Upload images before navigating to preview
            let imgObj = { ...updateDataImage, ...updateDataImageBack };
            const imageObjectsCombinedArr = [...IdCardData?.view_data?.id_front?.image_objects, ...IdCardData?.view_data?.id_back?.image_objects];

            for (let i = 0; i < Object.keys(imgObj).length; i++) {
                const imgKey = Object.keys(imgObj)[i];
                const imgValue = imgObj[imgKey];
                
                // Only upload if it's a data URL
                if (imgValue?.split(':')[0] == 'data') {
                    const imageObj = imageObjectsCombinedArr?.find(img => img?.tag == imgKey);
                    if (!imageObj) {
                        setPreviewLoading(false);
                        return enqueueSnackbar('Index Error Uploading Image !!!', { variant: 'error' });
                    }

                    // Get removeBG value from image object (1 if true, 0 if false)
                    const removeBGValue = imageObj?.removeBG === true ? 1 : 0;

                    let imgLink = await uploadImgToBucket(
                        dataURLtoFile(imgValue, state?.teacher_idCreate_userID || IdCardData?.id),
                        removeBGValue,
                        imgKey
                    );
                    
                    if (!imgLink) {
                        setPreviewLoading(false);
                        return enqueueSnackbar('Error Uploading Image !!!', { variant: 'error' });
                    }
                    
                    imgObj = { ...imgObj, [imgKey]: imgLink };
                }
            }

            // Update cardObj with uploaded image links
            let cardObj = { ...IdCardData };

            // ID FRONT
            const frontUpdatedTextObjects = [];
            IdCardData.view_data.id_front.text_objects?.forEach(t => frontUpdatedTextObjects.push({ ...t, text:  t.tag === "class_id" && !updateDataTextField["class_id"] ? classId : updateDataTextField[t.tag] }));

            const frontUpdatedImageObjects = [];
            IdCardData.view_data.id_front.image_objects?.forEach(t => {
                const imgKey = t.tag;
                frontUpdatedImageObjects.push({ ...t, src: imgObj[imgKey] || updateDataImage[imgKey] || t.src });
            });

            cardObj.view_data.id_front.text_objects = frontUpdatedTextObjects;
            cardObj.view_data.id_front.image_objects = frontUpdatedImageObjects;

            // ID BACK
            if (IdCardData.type == 2) {
                const backUpdatedTextObjects = [];
                IdCardData.view_data.id_back.text_objects?.forEach(t => backUpdatedTextObjects.push({ ...t, text:  t.tag === "class_id" && !updateDataTextField["class_id"] ? classId : updateDataTextFieldBack[t.tag] }));

                const backUpdatedImageObjects = [];
                IdCardData.view_data.id_back.image_objects?.forEach(t => {
                    const imgKey = t.tag;
                    backUpdatedImageObjects.push({ ...t, src: imgObj[imgKey] || updateDataImageBack[imgKey] || t.src });
                });

                cardObj.view_data.id_back.text_objects = backUpdatedTextObjects;
                cardObj.view_data.id_back.image_objects = backUpdatedImageObjects;
            }

            const customState = state || ionRouter?.routeInfo?.routeOptions;
            
            // Separate uploaded images back into front and back
            const uploadedFrontImages = {};
            const uploadedBackImages = {};
            
            Object.keys(updateDataImage).forEach(key => {
                uploadedFrontImages[key] = imgObj[key] || updateDataImage[key];
            });
            
            Object.keys(updateDataImageBack).forEach(key => {
                uploadedBackImages[key] = imgObj[key] || updateDataImageBack[key];
            });
            
            // Ensure class_id is included in user_data from current state
            const userDataWithClassId = { ...updateDataTextField, ...updateDataTextFieldBack };
            // Add class_id if it exists in the form and ensure it's set from current classId state
            if (IdCardData?.view_data?.id_front?.text_objects?.some(t => t.tag === 'class_id')) {
                userDataWithClassId['class_id'] = updateDataTextField['class_id'] || classId || '';
            }
            if (IdCardData?.type == 2 && IdCardData?.view_data?.id_back?.text_objects?.some(t => t.tag === 'class_id')) {
                userDataWithClassId['class_id'] = updateDataTextFieldBack['class_id'] || classId || userDataWithClassId['class_id'] || '';
            }
            
            // Navigate to preview with uploaded image links
            history.push("/preview", {
                ...customState,
                user_data: userDataWithClassId,
                img_data: { 
                    updateDataImage: uploadedFrontImages,
                    updateDataImageBack: uploadedBackImages
                },
                cData: cardObj,
                downloaded: state?.downloaded,
            });
        } catch (error) {
            console.log(error);
            enqueueSnackbar('Error uploading images, Please Try Again !!!', { variant: 'error' });
        } finally {
            setPreviewLoading(false);
        }
    }

    const filterImg = async () => {
        const { value } = await Preferences.get({ key: 'gjaii_IDCARD_user' });
        if (value == 'undefined' || !JSON.parse(value)?.id) return enqueueSnackbar('Something Went Wrong !!!', { variant: 'error' });
        // if (!state.cData?.id) return enqueueSnackbar('Something Went Wrong !!!', { variant: 'error' });

        setSaveLoading(true);

        let imgObj = { ...updateDataImage, ...updateDataImageBack }
        const imageObjectsCombinedArr = [...state?.cData?.view_data?.id_front?.image_objects, ...state?.cData?.view_data?.id_back?.image_objects]

        for (let i = 0; i < Object.keys(imgObj).length; i++) {
            const imgKey = Object.keys(imgObj)[i];
            const imgValue = imgObj[imgKey];
            
            if (imgValue?.split(':')[0] == 'data') {
                const imageObj = imageObjectsCombinedArr?.find(img => img?.tag == imgKey);
                if (!imageObj) return enqueueSnackbar('Index Error Uploading Image !!!', { variant: 'error' });

                // Get removeBG value from image object (1 if true, 0 if false)
                const removeBGValue = imageObj?.removeBG === true ? 1 : 0;

                let imgLink = await uploadImgToBucket(
                    dataURLtoFile(imgValue, state?.teacher_idCreate_userID || state.cData?.id),
                    removeBGValue,
                    imgKey
                )
                imgObj = { ...imgObj, [imgKey]: imgLink }
            }
        }

        onSaveCard(imgObj);
    }

    const uploadImgToBucket = async (img, removeBG, imgKey) => {
        let link = ''
        const fData = new FormData();
        fData.append('image', img);
        
        // Check if role is "parent" and set removeBG to 0
        const { value: roleValue } = await Preferences.get({ key: 'gjaai_role' });
        const role = roleValue;
        const finalRemoveBG = role === 'parent' ? 0 : removeBG;
        
        // Always append removeBG based on the role or passed value (1 or 0)
        fData.append('removeBG', finalRemoveBG);

        await axios.post(`${process.env.REACT_APP_BASE_URL}/user/createlink`, fData)
            .then(res => {
                if (res.data.success) {
                    link = res.data.image_link;
                } else {
                    enqueueSnackbar(res.data.message, { variant: 'error' });
                }
            })
            .catch(err => {
                console.log(err);
                enqueueSnackbar('Error, Please Try Again !!!', { variant: 'error' });
            })

        return link;
    }

    const onSaveCard = async (img_data) => {
        let body = {};
        let url = '';

        // Ensure class_id is included in user_data from current state
        const userDataWithClassId = { ...updateDataTextField, ...updateDataTextFieldBack, ...img_data };
        // Add class_id if it exists in the form and ensure it's set from current classId state
        if (IdCardData?.view_data?.id_front?.text_objects?.some(t => t.tag === 'class_id')) {
            userDataWithClassId['class_id'] = updateDataTextField['class_id'] || classId || '';
        }
        if (IdCardData?.type == 2 && IdCardData?.view_data?.id_back?.text_objects?.some(t => t.tag === 'class_id')) {
            userDataWithClassId['class_id'] = updateDataTextFieldBack['class_id'] || classId || userDataWithClassId['class_id'] || '';
        }

        if (state?.cardUpdate) { // Update ID
            if (!state.mapped_id) return enqueueSnackbar('Something Went Wrong !!!', { variant: 'error' });

            url = `${process.env.REACT_APP_BASE_URL}/user/updatecardmapping`;
            body = {
                is_verified: 0,
                id: state.mapped_id,
                user_data: userDataWithClassId,
                // viaForm: 1
            }
        } else { // Sending Verification Or Already Verified If Teacher is Creating
            const { value } = await Preferences.get({ key: 'gjaii_IDCARD_user' });

            if (!state.cData?.id) return enqueueSnackbar('Something Went Wrong !!!', { variant: 'error' });

            url = `${process.env.REACT_APP_BASE_URL}/user/createcardmap`;
            body = {
                icardid: state.cData?.id,
                userid: state?.teacher_idCreate_userID || JSON.parse(value)?.id,
                user_data: userDataWithClassId,
                // viaForm: 1
                is_verified: 2
            }
            // console.log(body);
            // return;
        }

        await onUpdateUsername();

        await axios.post(url, body)
            .then(res => {
                if (res.data.success) {
                    enqueueSnackbar('ID Card Saved !!!', { variant: 'success' });
                    if (state?.cardUpdate) {
                        if (state?.after_update_push == 'goBack') {
                            history.goBack();
                        } else {
                            if (state?.teacherVerify_modalData) {
                                ionRouter.push(
                                    state?.after_update_push, "back", "pop",
                                    {
                                        ...state?.teacherVerify_modalData,
                                        pending_card: ionRouter?.routeInfo?.lastPathname == "/teacher/verify-id" ? true : false,
                                        header_title: ionRouter?.routeInfo?.lastPathname == "/teacher/verify-id" ? "Pending ID" : 'Final ID'
                                    }
                                )
                            } else {
                                history.push(state?.after_update_push);
                            }
                        }
                    } else {
                        if (state?.teacher_idCreate) {
                            history.push("/teacher/create-id");
                        } else {
                            history.push("/content", { ...state });
                        }
                    }
                } else {
                    enqueueSnackbar(res.data.message, { variant: 'error' });
                }
                setSaveLoading(false);
            })
            .catch(err => {
                console.log(err);
                setSaveLoading(false);
                enqueueSnackbar('Error, Please Try Again !!!', { variant: 'error' });
            })
    }

    const onUpdateUsername = async () => {
        if (!updateDataTextField[state?.cData?.view_data?.id_front?.text_objects?.[0]?.tag]) return;

        const body = {
            user_id: state?.user_id,
            first_name: updateDataTextField[state?.cData?.view_data?.id_front?.text_objects?.[0]?.tag]
        }

        await axios.post(`${process.env.REACT_APP_BASE_URL}/user/updateusername`, body)
            .then(res => {
                if (res.data.success) {
                    console.log('username upadated');
                } else {
                    enqueueSnackbar(res.data.message, { variant: 'error' });
                    setSaveLoading(false);
                    throw new Error('Update User Name Error !!!');
                }
            })
            .catch(err => {
                console.log(err);
                enqueueSnackbar('Error, Please Try Again !!!', { variant: 'error' });
                setSaveLoading(false);
            })
    }

    const onEditClick = async (src, key, type) => {
        if (!src) return enqueueSnackbar('No Image Found !!!');

        setEditImage(src);
        setIsEditModalOpen(true);
        setupdateDataImageKey(key);
        setupdateDataImageType(type);
        if (state?.teacherVerify_edit) setUpdateDataImageFrontBackNew({ ...updateDataImageFrontBackNew, [key]: false })
    }

    const onEditCropSave = () => {
        const cropper = cropperRef.current?.cropper;

        if (updateDataImageType == 'front') {
            setUpdateDataImage({ ...updateDataImage, [updateDataImageKey]: cropper.getCroppedCanvas().toDataURL() })
        } else {
            setUpdateDataImageBack({ ...updateDataImageBack, [updateDataImageKey]: cropper.getCroppedCanvas().toDataURL() })
        }

        setIsEditModalOpen(false);
    };

    const onOpenSignaturePad = (key, type) => {
        setupdateDataImageKey(key);
        setupdateDataImageType(type);
        setIsSignatureModalOpen(true);
        if (state?.teacherVerify_edit) setUpdateDataImageFrontBackNew({ ...updateDataImageFrontBackNew, [key]: true });
        
        // Clear signature pad when opening and resize canvas
        requestAnimationFrame(() => {
            if (signaturePadRef.current && signatureContainerRef.current) {
                signaturePadRef.current.clear();
                // Resize canvas to match container with fixed aspect ratio
                setTimeout(() => {
                    resizeSignatureCanvas();
                }, 50);
            }
        });
    };

    // Handle signature canvas resize when modal opens or window resizes
    useEffect(() => {
        if (isSignatureModalOpen) {
            // Resize canvas after modal is fully opened - use multiple attempts to ensure it works
            const resizeWithRetry = () => {
                requestAnimationFrame(() => {
                    resizeSignatureCanvas();
                    // Retry after a short delay to ensure container is fully rendered
                    setTimeout(() => {
                        requestAnimationFrame(() => {
                            resizeSignatureCanvas();
                        });
                    }, 100);
                });
            };

            const timer = setTimeout(resizeWithRetry, 300);

            // Handle window resize
            const handleResize = () => {
                requestAnimationFrame(() => {
                    resizeSignatureCanvas();
                });
            };

            window.addEventListener('resize', handleResize);
            window.addEventListener('orientationchange', handleResize);

            return () => {
                clearTimeout(timer);
                window.removeEventListener('resize', handleResize);
                window.removeEventListener('orientationchange', handleResize);
            };
        }
    }, [isSignatureModalOpen])

    const resizeSignatureCanvas = () => {
        if (!signaturePadRef.current || !signatureContainerRef.current) return;
        
        const container = signatureContainerRef.current.querySelector('.update_signaturePadWrapper');
        if (!container) return;

        const canvas = signaturePadRef.current.getCanvas();
        if (!canvas) return;

        // Get the actual displayed size from the container
        const containerRect = container.getBoundingClientRect();
        // Account for padding (10px on each side = 20px total)
        const padding = 20;
        const displayWidth = Math.max(containerRect.width - padding, 300); // Minimum 300px width
        const displayHeight = (displayWidth * 400) / 540; // Maintain 1.8:1 aspect ratio (taller)// Maintain 1.35:1 aspect ratio (even taller)
        
        // Use 1:1 mapping for touch coordinates - don't scale with DPR
        // This ensures touch events map correctly to canvas coordinates on mobile
        // The canvas internal dimensions must match the CSS display dimensions exactly
        const currentWidth = canvas.width;
        const currentHeight = canvas.height;
        
        // Only resize if dimensions actually changed to avoid unnecessary redraws
        if (Math.abs(currentWidth - displayWidth) > 1 || Math.abs(currentHeight - displayHeight) > 1) {
            // Store existing signature data before resize
            const existingData = signaturePadRef.current.isEmpty() ? null : signaturePadRef.current.toDataURL();
            
            // Set canvas internal dimensions (1:1 with display size for accurate touch mapping)
            canvas.width = displayWidth;
            canvas.height = displayHeight;
            
            // Set CSS dimensions to match exactly
            canvas.style.width = displayWidth + 'px';
            canvas.style.height = displayHeight + 'px';
            
            // Restore signature if it existed
            if (existingData) {
                signaturePadRef.current.fromDataURL(existingData);
            }
        }
    };

    const onClearSignature = () => {
        if (signaturePadRef.current) {
            signaturePadRef.current.clear();
        }
    };

    const onSaveSignature = () => {
        if (!signaturePadRef.current) return;

        const isEmpty = signaturePadRef.current.isEmpty();
        if (isEmpty) {
            enqueueSnackbar('Please sign before saving', { variant: 'warning' });
            return;
        }

        // Get the canvas
        const canvas = signaturePadRef.current.getCanvas();
        
        // Ensure canvas dimensions are properly set before capturing
        // This ensures we capture the entire signature area
        const container = signatureContainerRef.current?.querySelector('.update_signaturePadWrapper');
        if (container) {
            const containerRect = container.getBoundingClientRect();
            const padding = 20;
            const displayWidth = Math.max(containerRect.width - padding, 300);
            const displayHeight = (displayWidth * 400) / 540; // Maintain 1.35:1 aspect ratio (even taller)
            
            // Make sure canvas internal dimensions match display dimensions
            if (Math.abs(canvas.width - displayWidth) > 1 || Math.abs(canvas.height - displayHeight) > 1) {
                const existingData = signaturePadRef.current.toDataURL();
                canvas.width = displayWidth;
                canvas.height = displayHeight;
                canvas.style.width = displayWidth + 'px';
                canvas.style.height = displayHeight + 'px';
                signaturePadRef.current.fromDataURL(existingData);
            }
        }
        
        // Save the entire canvas without trimming to preserve the full signature
        // Convert full canvas to data URL with high quality
        const signatureDataUrl = canvas.toDataURL('image/png', 1.0);
        
        // Save signature to appropriate state
        if (updateDataImageType === 'front') {
            setUpdateDataImage({
                ...updateDataImage,
                [updateDataImageKey]: signatureDataUrl,
            });
        } else {
            setUpdateDataImageBack({
                ...updateDataImageBack,
                [updateDataImageKey]: signatureDataUrl,
            });
        }

        // Reset and close modal
        setIsSignatureModalOpen(false);
        setupdateDataImageKey(null);
        setupdateDataImageType(null);
        if (signaturePadRef.current) {
            signaturePadRef.current.clear();
        }
    };

    return (
        <IonicPageWrapper
            headerTitle='Update'
            onBackClick={state?.teacherVerify_edit ? null : () => ionRouter.push("/login", "back", "pop")}
        >
            <div id="update">
                {loading ? <CircularProgress sx={{ color: '#003554', display: 'block', margin: 'auto' }} /> : (
                    <>
                        <section className='update_cont' >
                            <h1 className='update_cont_header'>Form For Updating ID Card</h1>
                            {IdCardData.type == 2 && <h4 className='update_cont_subheader'>ID Front</h4>}

                            <form onSubmit={handleSubmit} className='update_cont_form' >
                                {/* ID FRONT */}
                                {IdCardData?.view_data?.id_front.text_objects.map((t, i) => {
                                    if (t.tag === 'class_id') {
                                        return (
                                            <TextField
                                                select
                                                label="Class ID"
                                                fullWidth
                                                key={i}
                                                onChange={(e) => setUpdateDataTextField({ ...updateDataTextField, [t.tag]: e.target.value })}
                                                value={updateDataTextField[t.tag] || classId}
                                                helperText={`${t?.toolkit_text} ${t?.max_length && `${t?.toolkit_text && "| "}Max Length: ${t.max_length}`}`}
                                                disabled={true}
                                            >
                                                {allClassData?.map((c) => (
                                                    <MenuItem
                                                        key={c?.classid}
                                                        value={`${c?.standard} ${c?.division ? `- ${c.division}` : ""}`}
                                                    >
                                                        {`${c?.standard} ${c?.division ? `- ${c.division}` : ""}`}
                                                    </MenuItem>
                                                ))}
                                            </TextField>
                                        );
                                    } else if (!!t?.options) {
                                        return (
                                            <TextField
                                                select
                                                label={
                                                    <span>
                                                        {t.tag}
                                                        {t.required && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}
                                                    </span>
                                                }
                                                fullWidth
                                                key={i}
                                                onChange={(e) => setUpdateDataTextField({ ...updateDataTextField, [t.tag]: e.target.value })}
                                                value={updateDataTextField[t.tag]}
                                                helperText={`${t?.toolkit_text} ${t?.max_length && `${t?.toolkit_text && "| "}Max Length: ${t.max_length}`}`}
                                                required={t.required || false}
                                            >

                                                {t?.options?.split(',')?.map((c, i) => ( // Options loading
                                                    <MenuItem key={i} value={c} >{c}</MenuItem>
                                                ))}
                                            </TextField>
                                        )
                                    } else {
                                        return (
                                            <StandardTextfield 
                                                label={
                                                    <span>
                                                        {t.tag}
                                                        {t.required && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}
                                                    </span>
                                                }
                                                variant="outlined" 
                                                key={i} 
                                                name={t.tag} 
                                                maxLength={t?.max_length}
                                                helperText={`${t?.toolkit_text} ${t?.max_length && `${t?.toolkit_text && '| '}Max Length: ${t.max_length}`}`}
                                                value={updateDataTextField[t.tag]} 
                                                setValue={setUpdateDataTextField} 
                                                spreadValue={updateDataTextField}
                                                required={t.required || false}
                                                // value={t.tag === "Name" ? name : t.tag === "Mobile No."? mobileNo : updateDataTextField[t.tag]} setValue={setUpdateDataTextField} spreadValue={updateDataTextField}
                                                prefix={t?.prefix}
                                                // display={t.tag === "Mobile No." ? 1 : 0}
                                            />
                                        )
                                    }
                                })}

                                {Object?.keys(updateDataImage)?.map((t, i) => {
                                    const imgObj = IdCardData?.view_data?.id_front?.image_objects?.find(img => img?.tag === t)

                                    if (!imgObj?.adminImage) {
                                        return (
                                            <div key={i} >
                                                {!updateDataImage[t] && imgObj?.tag?.toLocaleLowerCase() === "Photo".toLocaleLowerCase() && !imgObj?.src && (
                                                    <img src={frontViewImg} className='update_cropfrontView' />
                                                )}
                                                {!updateDataImage[t] && (imgObj?.signature || imgObj?.tag?.toLocaleLowerCase() === "sign".toLocaleLowerCase() || imgObj?.tag?.toLocaleLowerCase() === "signature".toLocaleLowerCase()) && !imgObj?.src && (
                                                    <img src={uploadSignature} className='update_cropfrontView' />
                                                )}

                                                {imgObj?.signature ? (
                                                    <div className="update_uploadBtnCont">
                                                        <Button variant="contained" color="primary" onClick={() => onOpenSignaturePad(t, 'front')}>
                                                            Sign {t}
                                                        </Button>
                                                    </div>
                                                ) : (
                                                    <div className="update_uploadBtnCont">
                                                        <Button variant="contained" component="label" style={{ marginRight: '5px' }}>
                                                            Select {t}
                                                            <input hidden accept="image/*" onChange={(e) => onSelectFile(e, t, 'front')} type="file" />
                                                        </Button>
                                                        <Button variant="contained" component="label" style={{ marginLeft: '5px' }} color='secondary' >
                                                            Use Camera
                                                            <input hidden capture accept="image/*" onChange={(e) => onSelectFile(e, t, 'front')} type="file" />
                                                        </Button>
                                                    </div>
                                                )}
                                                {!!imgObj?.src && !imgObj?.signature && (
                                                    <Button variant='contained' style={{ display: 'block', margin: '10px auto 15px', backgroundColor: '#004D74' }}
                                                        onClick={(e) => onEditClick(imgObj?.src, t, 'front')}
                                                    >
                                                        Edit {t}
                                                    </Button>
                                                )}
                                                {imgObj?.signature && updateDataImage[t] && (
                                                    <Button variant='contained' style={{ display: 'block', margin: '10px auto 15px', backgroundColor: '#004D74' }}
                                                        onClick={() => onOpenSignaturePad(t, 'front')}
                                                    >
                                                        Re-sign {t}
                                                    </Button>
                                                )}
                                                {imgObj?.toolkit_text && <p className='update_btnHelperText'>{imgObj?.toolkit_text}</p>}

                                                {updateDataImage[t] && <img src={updateDataImage[t]} className='update_cropPreviewImg' />}
                                            </div>
                                        )
                                    }
                                })}

                                {/* ID BACK */}
                                {IdCardData.type == 2 && (
                                    <>
                                        <h4 className='update_cont_subheader'>ID Back</h4>

                                        {IdCardData?.view_data?.id_back.text_objects.map((t, i) => {
                                            if (t.tag === 'class_id') {
                                                return (
                                                    <TextField
                                                        select
                                                        label="Class ID"
                                                        fullWidth
                                                        key={i}
                                                        onChange={(e) =>
                                                            setUpdateDataTextFieldBack(
                                                                {
                                                                    ...updateDataTextFieldBack,
                                                                    [t.tag]:
                                                                        e.target.value,
                                                                }
                                                            )
                                                        }
                                                        value={
                                                            updateDataTextField[t.tag] || classId
                                                        }
                                                        helperText=

                                                        {`${t?.toolkit_text
                                                            } ${t?.max_length &&
                                                            `${t?.toolkit_text && "| "
                                                            }Max Length: ${t.max_length
                                                            }`
                                                            }`}
                                                    >
                                                        {allClassData?.map((c) => (
                                                            <MenuItem
                                                                key={c?.classid}
                                                                value={`${c?.standard
                                                                    } ${c?.division
                                                                        ? `- ${c.division}`
                                                                        : ""
                                                                    }`}
                                                            >
                                                                {`${c?.standard} ${c?.division ? `- ${c.division}` : ""}`}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                );
                                            } else if (!!t?.options) {
                                                return (
                                                    <TextField
                                                        select
                                                        label={
                                                            <span>
                                                                {t.tag}
                                                                {t.required && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}
                                                            </span>
                                                        }
                                                        fullWidth
                                                        key={i}
                                                        onChange={(e) => setUpdateDataTextFieldBack({ ...updateDataTextFieldBack, [t.tag]: e.target.value })}
                                                        value={updateDataTextFieldBack[t.tag]}
                                                        helperText={`${t?.toolkit_text} ${t?.max_length && `${t?.toolkit_text && "| "}Max Length: ${t.max_length}`}`}
                                                        required={t.required || false}
                                                    >

                                                        {t?.options?.split(',')?.map((c, i) => ( // Options loading
                                                            <MenuItem key={i} value={c} >{c}</MenuItem>
                                                        ))}
                                                    </TextField>
                                                )
                                            } else {
                                                return (
                                                    <StandardTextfield 
                                                        label={
                                                            <span>
                                                                {t.tag}
                                                                {t.required && <span style={{ color: 'red', marginLeft: '4px' }}>*</span>}
                                                            </span>
                                                        }
                                                        variant="outlined" 
                                                        key={i} 
                                                        name={t.tag} 
                                                        maxLength={t?.max_length}
                                                        helperText={`${t?.toolkit_text} ${t?.max_length && `${t?.toolkit_text && '| '}Max Length: ${t.max_length}`}`}
                                                        // value={t.tag === "Name" ? name : t.tag === "Mobile No."? mobileNo : updateDataTextFieldBack[t.tag]} setValue={setUpdateDataTextFieldBack} spreadValue={updateDataTextFieldBack}
                                                        value={updateDataTextFieldBack[t.tag]} 
                                                        setValue={setUpdateDataTextFieldBack} 
                                                        spreadValue={updateDataTextFieldBack}
                                                        required={t.required || false}
                                                        prefix={t?.prefix}
                                                        // display={t.tag === "Mobile No." ? 1 : 0}
                                                    />
                                                )
                                            }
                                        })}

                                        {Object?.keys(updateDataImageBack)?.map((t, i) => {
                                            const imgObj = IdCardData?.view_data?.id_back?.image_objects?.find(img => img?.tag === t)

                                            if (!imgObj?.src || imgObj?.src?.split(':')?.[0] === 'data') {
                                                return (
                                                    <div key={i} >
                                                        {!updateDataImageBack[t] && imgObj?.tag?.toLocaleLowerCase() === "Photo".toLocaleLowerCase() && !imgObj?.src && (
                                                            <img src={frontViewImg} className='update_cropfrontView' />
                                                        )}
                                                        {!updateDataImageBack[t] && (imgObj?.signature || imgObj?.tag?.toLocaleLowerCase() === "sign".toLocaleLowerCase() || imgObj?.tag?.toLocaleLowerCase() === "signature".toLocaleLowerCase()) && !imgObj?.src && (
                                                            <img src={uploadSignature} className='update_cropfrontView' />
                                                        )}

                                                        {imgObj?.signature ? (
                                                            <div className="update_uploadBtnCont">
                                                                <Button variant="contained" color="primary" onClick={() => onOpenSignaturePad(t, 'back')}>
                                                                    Sign {t}
                                                                </Button>
                                                            </div>
                                                        ) : (
                                                            <div className="update_uploadBtnCont">
                                                                <Button variant="contained" component="label" style={{ marginRight: '5px' }}>
                                                                    Select {t}
                                                                    <input hidden accept="image/*" onChange={(e) => onSelectFile(e, t, 'back')} type="file" />
                                                                </Button>

                                                                <Button variant="contained" component="label" style={{ marginLeft: '5px' }} color='secondary' >
                                                                    Use Camera
                                                                    <input hidden capture accept="image/*" onChange={(e) => onSelectFile(e, t, 'back')} type="file" />
                                                                </Button>
                                                            </div>
                                                        )}
                                                        {!!imgObj?.src && !imgObj?.signature && (
                                                            <Button variant='contained' style={{ display: 'block', margin: '10px auto 15px', backgroundColor: '#004D74' }}
                                                                onClick={(e) => onEditClick(imgObj?.src, t, 'back')}
                                                            >
                                                                Edit {t}
                                                            </Button>
                                                        )}
                                                        {imgObj?.signature && updateDataImageBack[t] && (
                                                            <Button variant='contained' style={{ display: 'block', margin: '10px auto 15px', backgroundColor: '#004D74' }}
                                                                onClick={() => onOpenSignaturePad(t, 'back')}
                                                            >
                                                                Re-sign {t}
                                                            </Button>
                                                        )}

                                                        {imgObj?.toolkit_text && <p className='update_btnHelperText'>{imgObj?.toolkit_text}</p>}

                                                        {updateDataImageBack[t] && <img src={updateDataImageBack[t]} className='update_cropPreviewImg' />}
                                                    </div>
                                                )
                                            }
                                        })}
                                    </>
                                )}

                                <div className='update_btnsCont' >
                                    {state?.teacherVerify_edit ? (
                                        <>
                                            <StandardButton label='Save & Back' variant='outlined' bg='transparent' disabled={saveLoading}
                                                onClick={filterImg} loading={saveLoading}
                                                sx={{ color: "darkgreen !important", border: '1px solid rgba(0, 100, 0, 0.5) !important' }}
                                            />
                                        </>
                                    ) : (
                                        
                                        <>
                                            <StandardButton label='Preview' type='submit' loading={previewLoading} disabled={previewLoading} />
                                        </>
                                    )}

                                </div>
                            </form>
                        </section>

                        <IonModal mode='ios' isOpen={isModalOpen} >
                            <IonHeader>
                                <IonToolbar>
                                    <IonButtons slot="start">
                                        <IonButton onClick={() => setIsModalOpen(false)}>{'<'}</IonButton>
                                    </IonButtons>
                                    <IonTitle>Crop</IonTitle>
                                </IonToolbar>
                            </IonHeader>
                            <IonContent className="ion-padding" fullscreen >
                                {image ? (
                                    <>
                                        <Cropper
                                            classes={{ containerClassName: 'update_cropperCont' }}
                                            image={image}
                                            crop={crop}
                                            zoom={zoom}
                                            aspect={0.75}
                                            onCropChange={setCrop}
                                            onZoomChange={setZoom}
                                            onCropComplete={(croppedAreaPercentage, croppedAreaPixels) => setCroppedArea(croppedAreaPixels)}
                                        />

                                        <h4>Adjust Photo in the box</h4>

                                        {/* <div className='slider'>
                                            <Slider
                                                min={1}
                                                max={3}
                                                step={0.1}
                                                value={zoom}
                                                onChange={(e, zoom) => setZoom(zoom)}
                                            />
                                        </div> */}

                                        <Button variant='contained' color='success' onClick={onSave} fullWidth>
                                            Save
                                        </Button>
                                    </>
                                ) : null}
                            </IonContent>
                        </IonModal>

                        {/* Edit Cropper */}
                        <IonModal mode='ios' isOpen={isEditModalOpen} >
                            <IonHeader>
                                <IonToolbar>
                                    <IonButtons slot="start">
                                        <IonButton onClick={() => setIsEditModalOpen(false)}>{'<'}</IonButton>
                                    </IonButtons>
                                    <IonTitle>Crop</IonTitle>
                                </IonToolbar>
                            </IonHeader>
                            <IonContent className="ion-padding" fullscreen >
                                {editImage ? (
                                    <>
                                        <EditCropper
                                            src={editImage}
                                            guides={true}
                                            checkCrossOrigin={true}
                                            ref={cropperRef}
                                            initialAspectRatio={0.75}
                                            aspectRatio={0.75}
                                            rotatable={false}
                                            cropBoxResizable={false}
                                            zoomTo={editCropperZoom}
                                            zoom={({ detail }) => setEditCropperZoom(detail?.ratio?.toFixed(2))}
                                            viewMode={1}
                                            dragMode='move'
                                            cropBoxMovable={false}
                                            style={{ height: '60%', width: '100%' }}
                                            autoCropArea={1}
                                            toggleDragModeOnDblclick={false}
                                        />

                                        <div className='slider update_editSlider'>
                                            <Slider
                                                min={0}
                                                max={4}
                                                step={0.01}
                                                value={editCropperZoom}
                                                onChange={(e, zoom) => setEditCropperZoom(zoom)}
                                            />
                                        </div>

                                        <Button variant='contained' color='success' onClick={onEditCropSave} fullWidth sx={{ marginTop: 3 }} >
                                            Save
                                        </Button>

                                    </>
                                ) : null}
                            </IonContent>
                        </IonModal>

                        {/* Signature Pad Modal */}
                        <IonModal mode='ios' isOpen={isSignatureModalOpen} >
                            <IonHeader>
                                <IonToolbar>
                                    <IonButtons slot="start">
                                        <IonButton onClick={() => {
                                            setIsSignatureModalOpen(false);
                                            if (signaturePadRef.current) {
                                                signaturePadRef.current.clear();
                                            }
                                        }}>{'<'}</IonButton>
                                    </IonButtons>
                                    <IonTitle>Sign Here</IonTitle>
                                </IonToolbar>
                            </IonHeader>
                            <IonContent className="ion-padding" fullscreen >
                                <div className="update_signatureContainer" ref={signatureContainerRef}>
                                    <p style={{ 
                                        textAlign: 'center', 
                                        marginBottom: '10px', 
                                        fontSize: '14px', 
                                        color: '#666',
                                        fontWeight: '500'
                                    }}>
                                        Sign in the box below
                                    </p>
                                    <div className="update_signaturePadWrapper" style={{
                                        border: '2px solid #ccc',
                                        borderRadius: '8px',
                                        padding: '10px',
                                        backgroundColor: '#fff',
                                        marginBottom: '20px'
                                    }}>
                                        <SignatureCanvas
                                            ref={signaturePadRef}
                                            canvasProps={{
                                                className: 'signature-canvas',
                                                style: {
                                                    touchAction: 'none',
                                                    display: 'block',
                                                    margin: '0 auto',
                                                    width: '100%',
                                                    height: 'auto',
                                                    maxWidth: '100%',
                                                    WebkitTouchCallout: 'none',
                                                    WebkitUserSelect: 'none',
                                                    userSelect: 'none'
                                                }
                                            }}
                                            backgroundColor="rgba(255, 255, 255, 0)"
                                            penColor="rgb(0, 0, 0)"
                                            velocityFilterWeight={0.7}
                                            minWidth={1.5}
                                            maxWidth={3}
                                            throttle={0}
                                        />
                                    </div>
                                    <div className="update_signatureButtons" style={{
                                        display: 'flex',
                                        gap: '15px'
                                    }}>
                                        <Button 
                                            variant='outlined' 
                                            color='error' 
                                            onClick={onClearSignature} 
                                            fullWidth
                                            style={{ minHeight: '48px', fontSize: '16px' }}
                                        >
                                            Clear
                                        </Button>
                                        <Button 
                                            variant='contained' 
                                            color='success' 
                                            onClick={onSaveSignature} 
                                            fullWidth
                                            style={{ minHeight: '48px', fontSize: '16px' }}
                                        >
                                            Save Signature
                                        </Button>
                                    </div>
                                </div>
                            </IonContent>
                        </IonModal>
                    </>
                )}
            </div>
        </IonicPageWrapper>
    )
}

export default Update